<template>
    <div class="babel-header-template">

        <Section title="文件位置">
            <div style="padding: 20px">src / views / Main / Modules / LabelHeader / Label1.vue</div>
        </Section>


        <Section>
            <LabelHeader title="默认标题方式"></LabelHeader>
        </Section>


        <Section>
            <LabelHeader>
                <span slot="before">自定义标题方式<font color="red">(自定义)</font></span>
            </LabelHeader>
        </Section>


        <Section>
            <LabelHeader title="带按钮方式">

                <div slot="after">
                    <Button type="primary" size="small">新增</Button>
                </div>
            </LabelHeader>
        </Section>


        <Section style=" padding: 20px 0">
            <LabelHeader border title="有下划线">
            </LabelHeader>
        </Section>


        <Section style=" padding: 20px 0">
            <LabelHeader border="top" title="有上划线">
            </LabelHeader>
        </Section>


        <Section style=" padding: 20px 0">
            <LabelHeader border="top-bottom" title="上下划线">
            </LabelHeader>
        </Section>
    </div>
</template>

<script>

    import LabelHeader from '@/modules/LabelHeader'

    import { Button } from 'iview';

    export default {
        name: "Label1",
        components: {
            LabelHeader,
            Button
        }
    }
</script>

<style scoped>

</style>
